export function xRayResetAction() {
  const { t } = useI18n();

  return {
    getTitle: () => t('components.xeokit_viewer.context_menu.reset_x_ray') || 'Reset X-Ray',
    getEnabled: function (context) {
      return context.viewer.scene.numXRayedObjects > 0;
    },
    doAction: function (context) {
      context.viewer.scene.setObjectsXRayed(context.viewer.scene.xrayedObjectIds, false);

      // @ts-ignore xeokit
      // context.viewer.scene.xrayMaterial.preset = EmphasisMaterial.presets['sepia'];

      context.viewer.scene.xrayMaterial.fillAlpha = 0.4;
      context.viewer.scene.xrayMaterial.fillColor = [
        0.970588207244873, 0.7965892553329468, 0.6660899519920349,
      ];
      context.viewer.scene.xrayMaterial.edges = true;
      context.viewer.scene.xrayMaterial.edgeAlpha = 1.0;
      context.viewer.scene.xrayMaterial.edgeColor = [
        0.529411792755127, 0.4577854573726654, 0.4100345969200134,
      ];
      context.viewer.scene.xrayMaterial.edgeWidth = 1;
    },
  };
}
